import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { PathCard } from '@/shared/ui/path-card'

export const Route = createFileRoute('/_auth/users/')({
  staticData: {
    meta: {
      title: 'Пользователи',
      description: '',
    },
  },
  component: RouteComponent,
})
function RouteComponent() {
  const { t } = useTranslation()
  return (
    <PageWrapper title={t('Пользователи')}>
      <PathCard path="/users/apk/list" title={t('Пользователи АПК')} />
      <PathCard path="/users/students" title={t('Ученики')} />
      <PathCard path="/users/parents" title={t('Родители')} />
      <PathCard path="/users/employees" title={t('Сотрудники')} />
    </PageWrapper>
  )
}
